import Router from "next/router";
import React from "react";
import { IoMdClose } from "react-icons/io";

import CartStorage from "../../services/frontend/CartStorage";
import { getPrice, truncateTo2Decimals } from "../../services/frontend/pricing.service";
import { getStockAvailability } from "../../services/helper";
import { trackEvent } from "../../utils/analytics";
import { EVENTS } from "../../utils/analyticsConfig";
import LoaderComponent from "../Loader";
import BagItem from "./BagItem";

export default class Basket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      refresh: false,
      pageHeight: 0,
      newBottom: false,
      isStockAvailable: false,
    };
  }

  componentDidMount() {
    this._isBasketMounted = true;
    this.setState({ pageHeight: window.innerHeight });
    window.addEventListener("resize", this.handleWindowResize, true);
    this.handleWindowResize();
    getStockAvailability(this.props.cartData.products).then((isStockAvailable) => {
      if (this._isBasketMounted) {
        this.setState({ isStockAvailable });
      }
    });
  }

  componentWillUnmount() {
    this._isBasketMounted = false;
    if (this.removeTimer) {
      clearTimeout(this.removeTimer);
    }
    window.removeEventListener("resize", this.handleWindowResize, true);
  }

  handleWindowResize = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  removeProductFromCart = (productId) => () => {
    const cartData = this.props.cartData;
    const filteredProducts = cartData.products.filter((product) => product.id !== productId);
    if (filteredProducts.length === 0) {
      this.props.handleShowCart(false);
      if (!this.props.fromProductPage) this.props.setRefresh();
      if (this.props.setHideInAdvance) {
        this.props.setHideInAdvance(true);
      }
    }
    const timerId = setTimeout(async () => {
      cartData.products = filteredProducts;
      await CartStorage.saveCart(cartData);
      if (this.props.fromProductPage) {
        this.props.setCart(cartData, true);
      } else {
        this.props.setCart(cartData);
      }
      this.setState({ refresh: !this.state.refresh });
      if (this.props.updateAddedToCart) {
        this.props.updateAddedToCart(productId, false);
      }
    }, 300);
    this.removeTimer = timerId;
  };

  updateProductCount = async (productId, variant, count) => {
    const cartData = this.props.cartData;
    const productIndex = cartData.products.findIndex(
      (product) => product.id === productId && product.size === variant,
    );
    if (productIndex < 0) return;

    cartData.products[productIndex].quantity = count;
    await CartStorage.saveCart(cartData);
    this.props.setCart(cartData);
    this.setState({ refresh: !this.state.refresh });
  };

  render() {
    const { productTotalPrice, shippingFee } = getPrice(
      { shippingCharge: this.props.store?.shippingCharge },
      this.props.cartData,
      null,
      null,
      this.props.store?.cohort,
    );
    const price = truncateTo2Decimals(productTotalPrice - shippingFee);

    const isCheckoutDisabled =
      this.props.store?.checkoutDisabled ||
      !this.props.cartData.products.length;
    // this.props.isProplanActive === false;

    return (
      <aside
        className={`fixed top-0 z-[101] m-0 h-screen w-full max-w-app overflow-hidden bg-background text-fontBackground opacity-0 transition-all duration-500 ease-in-out ${this.props.isBasketOpen ? "left-0 opacity-100" : "left-full"
          }`}
      >
        {this.state.loading && <LoaderComponent />}

        <div className="flex h-screen flex-col items-center overflow-y-auto p-6">
          <h2 className="relative m-0 w-full text-xl font-bold tracking-wider text-fontBackground">
            <span className="mr-3">🛍️</span> Your Bag
            {/* close button */}
            <button
              className="absolute right-0 z-50 inline-block border-none bg-transparent"
              onClick={() => this.props.handleShowCart(!this.props.isBasketOpen)}
              aria-label="Close cart"
            >
              <IoMdClose size={30} className="text-primary" />
            </button>
          </h2>

          <div className="my-10 mb-[50px] w-full">
            {React.Children.toArray(
              this.props.cartData.products.map((product) => (
                <BagItem
                  item={product}
                  removeProductFromCart={this.removeProductFromCart}
                  updateProductCount={this.updateProductCount}
                />
              )),
            )}
          </div>
          <div className="h-[120px] w-full"></div>
        </div>

        {this.props.isBasketOpen ? (
          <div className="fixed bottom-0 left-1/2 w-full max-w-app -translate-x-1/2 transform bg-background px-3 py-4 text-fontBackground shadow-[0_-1px_4.5px_0_#ccc]">
            <button
              className="w-full rounded-2xl border-none bg-primary bg-none py-4 font-normal uppercase tracking-wider text-fontPrimary outline-none"
              style={{
                opacity: isCheckoutDisabled ? 0.2 : 1,
              }}
              disabled={isCheckoutDisabled}
              onClick={async () => {
                console.log("checkout click");

                // Remove store property from products for tracking
                const productsWithoutStore = this.props.cartData.products.map(
                  ({ store, ...productWithoutStore }) => productWithoutStore,
                );
                trackEvent(EVENTS.CHECKOUT_STARTED, {
                  subdomain: this.props?.store?.subdomain,
                  cart_data: productsWithoutStore,
                });

                Router.push("/cart/checkout");
              }}
            >
              Checkout — ₹{price}
            </button>
            {/* <button
              className="bg-none border-none outline-none w-full py-4 rounded-2xl bg-white text-black text-sm font-bold tracking-wider uppercase"
              onClick={() => this.props.handleShowCart(!this.props.isBasketOpen)}
            >
              Continue Shopping
            </button> */}
          </div>
        ) : (
          ""
        )}
      </aside>
    );
  }
}
